module.exports = {
  Handler:  require('./SVGHandler'),
  Renderer: require('./SVGRenderer'),
  string: {
    Renderer : require('./SVGStringRenderer')
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/render/svg/index.js
// module id = 601
// module chunks = 0